import { Form } from 'antd';
import { cloneElement } from 'react';

import { fieldTypes } from '@/constants';

import styles from './FormItem.module.scss';

const FormItem = ({
    label,
    fieldType,
    fieldName,
    fieldRules,
    hidden,
    placeholder,
    required,
    requiredMsg,
    validators,
    children,
    ...formItemProps
}) => {
    const getActionText = () => {
        switch (fieldType) {
            case fieldTypes.SELECT:
            case fieldTypes.AUTOCOMPLETE:
            case fieldTypes.DATE:
                return 'Please select';
            case fieldTypes.UPLOAD:
            case fieldTypes.RADIO:
                return 'Please choose';
            default:
                return 'Please enter';
        }
    }

    const getPlaceHolder = () => {
        if (placeholder) {
            return placeholder;
        }
        if (!label) {
            return '';
        }

        return `${getActionText()} ${label?.toLowerCase() || ''}`;
    }

    const getRequiredMsg = () => {
        if (requiredMsg) {
            return requiredMsg;
        }
        if (!label) {
            return '';
        }

        return `${getActionText()} ${label}`;
    }

    const getRules = () => {
        const rules = [];
        if (required) {
            rules.push({
                required,
                message: getRequiredMsg()
            })
        }

        if (fieldRules?.length > 0) {
            fieldRules.forEach(validator => {
                rules.push(validator);
            });
        }

        if (validators?.length > 0) {
            validators.forEach(validator => {
                rules.push(validator);
            });
        }

        return rules;
    }

    return (
        <Form.Item
            label={label}
            name={fieldName}
            rules={[
                ...getRules()
            ]}
            hidden={hidden}
            className={styles.formItem}
            {...formItemProps}
        >
            {cloneElement(children, {
                ...(fieldType !== fieldTypes.BOOLEAN && { getPlaceHolder })
            })}
        </Form.Item>
    )
}

export default FormItem;
